import { render } from "./entry.html?vue&type=template&id=5647dd8c&scoped=true&ts=true"
import script from "./entry.ts?vue&type=script&lang=ts"
export * from "./entry.ts?vue&type=script&lang=ts"

import "./entry.scss?vue&type=style&index=0&id=5647dd8c&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5647dd8c"]])

export default __exports__